import React from 'react';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { withTranslation } from 'react-i18next';

// Constants
// import { issues } from '../../constants/issues'

// Actions
// import { gameActions } from '../../actions';

import Header from '../../components/Header';
import { DebriefMenu } from './debrief_menu';

class Offers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: 1,
    };

    // Bindings
    this.handleChange = this.handleChange.bind(this);
  }

  // componentDidMount(){
  //     if(this.props.match.params.id){
  //         this.props.dispatch(gameActions.fetchGames(this.props.match.params.id))
  //     }
  // }

  handleChange(e) {
    const n = e.target.name;
    const v = e.target.value;
    let data = {};
    data[n] = v;
    this.setState(data);
  }

  getIssuesDiff(of1, of2) {
    // console.log(of1.data, of2.data);
    const data1 = of1.data.map((issue) => {
      return { ...issue, ...{ values: issue.values.map((v) => v) } };
    });
    const data2 = of2.data.map((issue) => {
      return { ...issue, ...{ values: issue.values.map((v) => v) } };
    });

    const issues = data1.filter((d, di) => {
      const selected1 = d.values.find((v) => v.selected);
      const selected2 = data2[di].values.find((v) => v.selected);
      if (selected1 && selected2) return selected1.label !== selected2.label;
    });
    return issues;
  }

  setDefault(o) {
    let offer = JSON.parse(JSON.stringify(o));
    offer.data = offer.data.map((issue) => {
      // return {...issue, ...{ values: issue.values.map( v => v ) } }
      return { ...issue, ...{ values: [...issue.values.map((v) => v)] } };
    });
    offer.order = 0;
    offer.data = offer.data.map((issue, ii) => {
      issue.values = issue.values.map((v, vi) => {
        if (vi === 0) v.selected = true;
        else v.selected = false;
        return v;
      });
      return issue;
    });
    return offer;
  }

  render() {
    const { game, t } = this.props;

    let maxOffers = 0;
    let roundOffersPerGroup = [];
    if (game.data.groups && this.state.order > -1) {
      // Tag IssueByIssue
      roundOffersPerGroup = game.data.groups.map((p) => {
        maxOffers = p.items.length > maxOffers ? p.items.length : maxOffers;
        let realOrder = 0;
        p.items = p.items.map((it, i) => {
          const prev = i > 0 ? p.items[i - 1] : this.setDefault(p.items[0]);
          // console.log(prev, it)
          let diff = null;

          // prev = p.items[i-1];
          // IssueByIssue vs Multi-Issue
          diff = this.getIssuesDiff(prev, it);
          if (diff.length === 1) it.type = 'ibi';
          else it.type = 'pack';

          // Is this a MESOs offer?
          if (prev.order === it.order) {
            prev.type = 'meso';
            it.type = 'meso';
          }

          //   // Real counter
          //   if (prev.order !== it.order) {
          //     realOrder++;
          //   }
          realOrder++;
          it.realOrder = realOrder;

          return it;
        });
        return p;
      });
    }

    console.log({ roundOffersPerGroup });

    let offersIssueByIssue = 0;
    let offersPackage = 0;
    let offersMesos = 0;
    let offersFinished = 0;
    roundOffersPerGroup.map((groffers, goi) => {
      const goffersRound = groffers.items.filter(
        (of) => of.realOrder === parseInt(this.state.order)
      );
      const goLastOffer = groffers.items[groffers.items.length - 1];
      // console.log(goffersRound)

      if (
        goLastOffer &&
        goLastOffer.realOrder <= this.state.order &&
        goLastOffer.status === 'accepted'
      ) {
        offersFinished++;
      } else if (goffersRound.length === 1) {
        if (goffersRound[0].type === 'ibi') offersIssueByIssue++;
        if (goffersRound[0].type === 'pack') offersPackage++;
        if (goffersRound[0].type === 'meso') offersMesos++;
      } else if (goffersRound.length > 1) {
        offersMesos++;
      }
    });

    return (
      <div>
        <Header />

        <h2 className='mt-3 sec-title'>
          {t('Offers')}
          <small className='float-end'>
            <DebriefMenu
              game_id={game.data._id}
              location={this.props.location}
            />
          </small>
        </h2>

        <div className='row'>
          <div className='col-6 px-5'>
            <h5 className='mt-3'>{t('Issue-By-Issue')}:</h5>
            <p className='lead'>{t('ibiDescription')}</p>

            <h5 className='mt-5'>{t('Package Offer')}:</h5>
            <p className='lead'>{t('packageDescription')}</p>

            <h5 className='mt-5'>
              {t('Multiple Equivalent Simultaneous Offers')} (MESOs):
            </h5>
            <p className='lead'>{t('mesosDescription')}</p>
          </div>

          <div className='col-6 px-5'>
            <h5 className='text-center mt-3'>
              {t('Count of Offer Tactic Over Time')}
            </h5>
            <p className='lead text-center mb-0'>
              {t('Offer')}: {this.state.order}
            </p>
            <input
              name='order'
              type='range'
              min='1'
              max={maxOffers}
              value={this.state.order}
              onChange={this.handleChange}
            />

            <div className='mt-3'>
              <HighchartsReact
                highcharts={Highcharts}
                options={{
                  title: { text: '' },
                  chart: { type: 'column' },
                  credits: { enabled: false },
                  legend: { enabled: false },
                  xAxis: {
                    categories: [
                      t('Issue-By-Issue'),
                      t('Package Offer'),
                      t('Multiple Equivalent Simultaneous Offers'),
                      t('Count of Offer Tactic Over Time'),
                    ],
                  },
                  yAxis: {
                    title: { text: t('Count') },
                    allowDecimals: false,
                    min: 0,
                    max: game.data.groups ? game.data.groups.length + 1 : 10,
                  },
                  series: [
                    {
                      data: [
                        offersIssueByIssue,
                        offersPackage,
                        offersMesos,
                        offersFinished,
                      ],
                    },
                  ],
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { player, game } = state;
  return {
    game,
    player,
  };
}

const OffersWithTranslation = withTranslation()(Offers);
export const connectedPage = connect(mapStateToProps)(OffersWithTranslation);
export { connectedPage as GameOffers };

// const connectedPage = connect(mapStateToProps)(Offers);
// export { connectedPage as GameOffers };
